import DOMPurify from "dompurify";

/**
 * Everything Quill's default format registry can produce, since both rich text fields
 * are edited with ReactQuill on its default configuration. Video embeds are left out:
 * an iframe on the login page is worth more to an attacker than it is to an author.
 */
const ALLOWED_TAGS = [
    "p",
    "br",
    "span",
    "strong",
    "em",
    "u",
    "s",
    "code",
    "sub",
    "sup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "pre",
    "ol",
    "ul",
    "li",
    "a",
    "img",
];

// Quill carries alignment, indent, size and font as ql- classes, and colour as inline style
const ALLOWED_ATTR = ["class", "style", "href", "target", "rel", "src", "alt", "width", "height"];

/**
 * Cleans rich text authored by event coordinators and season managers, who are volunteers
 * rather than administrators. It is cleaned on render rather than on write so that rows
 * stored before this existed are covered too.
 */
export const sanitiseHtml = (html: string) => DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
